import React, { useState } from 'react';
import KapsoCatalogue from './KapsoCatalogue';
import KapsoCompanyTemplates from './KapsoCompanyTemplates';
import KapsoPhoneHealth from './KapsoPhoneHealth';
import KapsoProposals from './KapsoProposals';

/**
 * WhatsApp de AR (Kapso).
 *
 * Tres vistas. Las dos de plantillas se separan porque confundirlas sale caro:
 * el **catálogo** es el repertorio de ClaimUp y no está en marcha en ningún
 * sitio; lo que un cliente **tiene** es lo que de verdad se le puede enviar.
 *
 * La tercera es otra cosa: el **estado de los números** según Meta. Va aquí
 * porque es del mismo canal, pero se mira por otro motivo — no para configurar,
 * sino para enterarse antes de que restrinjan un número.
 */
const VISTAS = [
  { id: 'catalogo', label: 'Catálogo' },
  { id: 'clientes', label: 'Por cliente' },
  // Lo que proponen los clientes, para revisarlo antes de Meta (06-reparto §4.2).
  { id: 'propuestas', label: 'Propuestas de clientes' },
  { id: 'numeros', label: 'Estado de los números' },
];

const KapsoSettings = () => {
  const [vista, setVista] = useState('catalogo');

  return (
    <div className='space-y-4'>
      <div className='bg-white rounded-lg border border-slate-200 p-4'>
        <h2 className='text-base font-semibold text-slate-900'>WhatsApp AR · Kapso</h2>
        <p className='mt-1 text-sm text-slate-500'>
          Canal oficial de Meta para la gestión propia. Fuera de la ventana de 24 h solo se
          puede escribir con una plantilla aprobada.
        </p>
      </div>

      <div className='flex gap-1 border-b border-slate-200'>
        {VISTAS.map(v => (
          <button
            key={v.id}
            type='button'
            onClick={e => {
              setVista(v.id);
              e.target.blur();
            }}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors outline-none focus:outline-none ${
              vista === v.id
                ? 'border-blue-700 text-blue-700'
                : 'border-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>

      {vista === 'catalogo' && <KapsoCatalogue />}
      {vista === 'clientes' && <KapsoCompanyTemplates />}
      {vista === 'propuestas' && <KapsoProposals />}
      {vista === 'numeros' && <KapsoPhoneHealth />}
    </div>
  );
};

export default KapsoSettings;
